import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import {
	SelectControl,
	PanelBody,
	Button,
	__experimentalToolsPanelItem as ToolsPanelItem,
} from '@wordpress/components';
import {
	__experimentalColorGradientSettingsDropdown as ColorGradientSettingsDropdown,
	__experimentalUseMultipleOriginColorsAndGradients as useMultipleOriginColorsAndGradients,
	InspectorControls,
} from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';

const Appearance = ( props ) => {
	const { attributes, setAttributes, clientId } = props;
	const { overlayColor, animation, style, sound } = attributes;

	const colorGradientSettings = useMultipleOriginColorsAndGradients();
	const margin = { ...style?.spacing?.margin };

	const setMargins = ( values ) => {
		setAttributes( {
			style: {
				...style,
				spacing: {
					...style?.spacing,
					margin: values,
				},
			},
		} );
	};

	const siteUrl = useSelect( ( select ) => {
		const site = select( 'core' ).getSite();
		return site && site.url;
	} );

	return (
		<Fragment>
			<InspectorControls group="styles">
				<PanelBody
					title={ __( 'Animation & Sound', 'popper' ) }
					initialOpen={ false }
				>
					<SelectControl
						label={ __( 'Animation', 'popper' ) }
						value={ animation }
						options={ [
							{ label: __( 'None', 'popper' ), value: '' },
							{
								label: __( 'Slide in Top', 'popper' ),
								value: 'slide-in-top',
							},
							{
								label: __( 'Slide in Bottom', 'popper' ),
								value: 'slide-in-bottom',
							},
							{
								label: __( 'Slide in Right', 'popper' ),
								value: 'slide-in-right',
							},
							{
								label: __( 'Slide in Left', 'popper' ),
								value: 'slide-in-left',
							},
							{
								label: __( 'Unfold In', 'popper' ),
								value: 'unfoldIn',
							},
							{
								label: __( 'Puff In', 'popper' ),
								value: 'puff-in',
							},
							{
								label: __( 'Puff In Back', 'popper' ),
								value: 'puff-in-back',
							},
						] }
						onChange={ ( val ) =>
							setAttributes( { animation: val } )
						}
						__next40pxDefaultSize
						__nextHasNoMarginBottom
					/>
					<SelectControl
						label={ __( 'Sound', 'popper' ) }
						value={ sound }
						options={ [
							{ label: __( 'None', 'popper' ), value: '' },
							{
								label: __( 'Earth', 'popper' ),
								value: 'earth',
							},
							{
								label: __( 'Jupiter', 'popper' ),
								value: 'jupiter',
							},
							{
								label: __( 'Mars', 'popper' ),
								value: 'mars',
							},
							{
								label: __( 'Moon', 'popper' ),
								value: 'moon',
							},
							{
								label: __( 'Uranus', 'popper' ),
								value: 'uranus',
							},
						] }
						onChange={ ( val ) => {
							setAttributes( { sound: val } );
							new Audio(
								`${ siteUrl }/wp-content/plugins/popper/assets/audio/${ val }.mp3`
							).play();
						} }
						__next40pxDefaultSize
						__nextHasNoMarginBottom
					/>
				</PanelBody>
			</InspectorControls>
			<InspectorControls group="dimensions">
				<ToolsPanelItem
					hasValue={ () => !! margin }
					label={ __( 'Margin' ) }
					onDeselect={ () => setMargins( undefined ) }
					resetAllFilter={ () => setMargins( undefined ) }
					panelId={ clientId }
				>
					<Button
						text={ __( 'Reset margins' ) }
						onClick={ () => setMargins( undefined ) }
						variant="primary"
						size="small"
					/>
				</ToolsPanelItem>
			</InspectorControls>
			<InspectorControls group="color">
				<ColorGradientSettingsDropdown
					panelId={ clientId }
					settings={ [
						{
							colorValue: overlayColor,
							onColorChange: ( color ) =>
								setAttributes( { overlayColor: color } ),
							label: __( 'Overlay Color', 'popper' ),
							resetAllFilter: () =>
								setAttributes( { overlayColor: undefined } ),
							enableAlpha: true,
							clearable: true,
						},
					] }
					{ ...colorGradientSettings }
				/>
			</InspectorControls>
		</Fragment>
	);
};

export default Appearance;
